import { InputProps } from './types';

import * as S from './styles';

const Input: React.FC<InputProps> = ({ type, ...props }) => {
  const renderInput = () => {
    switch (type) {
      case 'number':
        return <S.StyledNumber {...props} />;
      case 'password':
        return <S.StyledPassword {...props} />;
      case 'email':
        return <S.StyledEmail {...props} />;
      case 'tel':
        return <S.StyledTel {...props} />;
      default:
        return <S.StyledInput {...props} />;
    }
  };

  return (
    <S.InputContainer error={props.error}>{renderInput()}</S.InputContainer>
  );
};

export default Input;
